module.exports = __webpack_public_path__ + "media/assets/images/category/Thanks@2x-c28ef5b4995e1dd8d8ea699a68b73105.png";